import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {InputMaskModule} from '@ngneat/input-mask';
import {ContentLoaderModule} from '@ngneat/content-loader';
import {AngularMaterialLibraryModule} from './angular-material/angular-material-library.module';
import {ComponentLibraryModule} from './components/component-library.module';
import {DirectiveLibraryModule} from './directives/directive-library.module';
import {PipeLibraryModule} from './pipes/pipe-library.module';
import {NgxMaskModule} from 'ngx-mask';
import {NgxCurrencyDirective} from 'ngx-currency';
import {BreakpointService} from "./services/breakpoint.service";
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';

const dbConfig: DBConfig  = {
  name: 'dynamoney',
  version: 1,
  objectStoresMeta: [{
    store: 'applications',
    storeConfig: { keyPath: 'status', autoIncrement: false },
    storeSchema: [
      { name: 'application_data', keypath: 'application_data', options: { unique: false } },
      { name: 'status', keypath: 'status', options: { unique: false } },
    ]
  }]
};

const modules = [
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  ContentLoaderModule,
  NgxCurrencyDirective,

  AngularMaterialLibraryModule,
  ComponentLibraryModule,
  DirectiveLibraryModule,
  PipeLibraryModule,
]

@NgModule({
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(),
    InputMaskModule.forRoot({inputSelector: 'input', isAsync: true}),
    NgxIndexedDBModule.forRoot(dbConfig),
    ...modules,
  ],
  exports: [
    ...modules,
    NgxMaskModule,
    InputMaskModule,
  ],
  providers: [
    { provide: BreakpointService, useClass: BreakpointService },
  ]
})
export class GrowUiLibraryModule { }

